import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export const SummaryBlock = ({ sections, large, extraClassName }) =>
  sections && sections.length > 0 ? (
    <div
      className={classnames(
        `${sections[0].baseClass}__summaryBlock`,
        'u-full-width u-full-height lh-h6',
        extraClassName,
        {
          [`${sections[0].baseClass}__summaryBlockLarge`]: large
        }
      )}
    >
      {sections.map(({ title, value, baseClass }) => (
        <div
          key={title}
          className={classnames(`${baseClass}__summaryBlock__section`, 'border p2-sm', {
            [`${baseClass}__summaryBlock__section_full`]: sections.length === 1
          })}
        >
          <div className='text-underline pb1-sm'>{title}</div>
          <div>{value}</div>
        </div>
      ))}
    </div>
  ) : null;

SummaryBlock.propTypes = {
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      baseClass: PropTypes.string.isRequired
    }).isRequired
  ).isRequired,
  large: PropTypes.bool,
  extraClassName: PropTypes.string
};

SummaryBlock.defaultProps = {
  large: false,
  extraClassName: ''
};

export default SummaryBlock;
